import { useContext } from "react";
import { pick } from "lodash";
import { AmplifyContext } from "./AmplifyContext";

export const useAmplifyContext = () => {
  const ctx = useContext(AmplifyContext);

  return { ...pick(ctx, ["margin", "setMargin", "setAmplification", "resetStates"]) };
};
